<script setup>
import {computed} from 'vue'

const props = defineProps({
    value: String,
    column: Object
})

const step = computed(() => {
    return parseFloat(props.column.step || '60')
})

const formattedTime = computed(() => {
    if (!props.value) return ''

    // Split Postgres time (HH:mm:ss.u)
    const [timePart, fractionalPart] = props.value.split('.')
    const [hours, minutes, seconds] = timePart.split(':')

    // 1. Milliseconds (Step is less than 1 second)
    if (step.value < 1) {
        const ms = fractionalPart ? fractionalPart.substring(0, 3).padEnd(3, '0') : '000'
        return `${hours}:${minutes}:${seconds}.${ms}`
    }

    // 2. Seconds (Step is less than 60 seconds)
    if (step.value < 60) {
        return `${hours}:${minutes}:${seconds}`
    }

    // 3. Minutes (Default / Step is 60 or greater)
    return `${hours}:${minutes}`
})
</script>

<template>
    <span v-html="formattedTime"/>
</template>